<template>
  <div class="w-full">
    <label v-if="label" class="block mb-[5px] text-[14px] text-content dark:text-content-dark mt-3">
      {{ label }}
    </label>

    <div class="flex flex-wrap gap-2 mt-2">
      <button
        v-for="option in options"
        :key="option.value.toString()"
        type="button"
        :aria-pressed="isSelected(option.value)"
        @click="selectOption(option.value)"
        class="flex-1 border rounded-[3px] py-3 px-4 cursor-pointer transition-all text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-main-button-bg/40"
        :class="[
          isSelected(option.value)
            ? 'border-main-button-bg bg-main-button-bg/10'
            : 'border-container-border dark:border-container-border-dark hover:border-muted-text dark:hover:border-muted-text-dark bg-input-bg dark:bg-input-bg-dark',
        ]"
      >
        <component
          :is="option.icon"
          v-if="option.icon"
          class="text-[20px] mb-2 mx-auto"
          aria-hidden="true"
        />
        <div class="text-sm font-medium text-heading dark:text-heading-dark">
          {{ option.label }}
        </div>
        <div
          v-if="option.description"
          class="text-xs text-content dark:text-content-dark mt-1"
        >
          {{ option.description }}
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Component } from "vue";

interface Option {
  label: string;
  value: string | number | boolean;
  description?: string;
  icon?: Component;
}

type ModelValueType = string | number | boolean | null | string[] | undefined;

const props = defineProps<{
  modelValue: ModelValueType;
  options: Option[];
  label?: string;
  multiple?: boolean;
}>();

const emit = defineEmits(["update:modelValue", "change"]);

const isSelected = (value: string | number | boolean): boolean => {
  if (props.multiple) {
    return (
      Array.isArray(props.modelValue) &&
      props.modelValue.includes(value as string)
    );
  }
  return props.modelValue === value;
};

const selectOption = (value: string | number | boolean) => {
  let newValue: ModelValueType;
  if (props.multiple) {
    const currentValues = Array.isArray(props.modelValue)
      ? [...props.modelValue]
      : [];
    const index = currentValues.indexOf(value as string);
    if (index > -1) {
      currentValues.splice(index, 1);
    } else {
      currentValues.push(value as string);
    }
    newValue = currentValues;
  } else {
    newValue = value;
  }
  emit("update:modelValue", newValue);
  emit("change", newValue);
};
</script>
